module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460950.6cd0365f.png";